import "./App.css";
import "../src/assets/css/style.css";
import { routes } from "./Components/Routes/routes";
import {
  Routes,
  Route,
  Navigate,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { useEffect } from "react";
import Login from "./Components/Authentication/Login";
import Register from "./Components/Authentication/Register";
import PinLock from "./Components/Authentication/PinLock";
import ProtectedRoute from "./Components/Protected/dashboardProtect";
import { adminroutes } from "./Adminpages/AdminRoutes";
import AdminLogIn from "./Adminpages/Authentication/Login";
import AdminLayout from "./Adminpages/Layout";
import LandingPage from "./LandingPage";
import { isSessionValid, isUnlocked } from "./utils/session";
// import LandingPage1 from "./LandingPage1";

const adminPaths = new Set(["/adminlogin", ...adminroutes.map((r) => r.path)]);

function RootGate() {
  const navigate = useNavigate();
  const hasSession = isSessionValid();

  useEffect(() => {
    if (hasSession && isUnlocked()) {
      navigate("/Dashboard", { replace: true });
    }
  }, [hasSession, navigate]);

  // A session exists — never show the marketing site. Either the PinLock
  // overlay (mounted globally in App) is unlocking it, or the redirect
  // above is already sending them to /Dashboard.
  if (hasSession) {
    return <div style={{ minHeight: "100vh", background: "#000" }} />;
  }

  return <LandingPage />;
}

function AdminModeToggle() {
  const location = useLocation();
  useEffect(() => {
    const isAdmin = adminPaths.has(location.pathname);
    document.getElementById("root").classList.toggle("admin-mode", isAdmin);
  }, [location.pathname]);
  return null;
}

function App() {
  const admin = localStorage.getItem("logindataen_admin");

  return (
    <>
      <AdminModeToggle />
      {/* <PinLock /> */}
      <Routes>
        {/* Public user routes */}
        {/* <Route path="/web1" element={<LandingPage1 />} />
        <Route path="/web2" element={<LandingPage />} /> */}
        <Route path="/" element={<RootGate />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/register/referral" element={<Register />} />

        {/* Admin login */}
        <Route path="/adminlogin" element={<AdminLogIn />} />

        {/* Admin protected routes */}
        {admin ? (
          adminroutes.map((route, i) => (
            <Route
              key={i}
              path={route.path}
              element={
                <AdminLayout
                  id={route.id}
                  navLink={route.path}
                  navItem={route.navItem}
                  component={route.component}
                />
              }
            />
          ))
        ) : (
          <Route
            path="/admindashboard"
            element={<Navigate to="/adminlogin" replace />}
          />
        )}

        {/* User protected routes */}
        {routes?.map((i, index) => (
          <Route
            key={index}
            path={i.path}
            element={<ProtectedRoute>{i.component}</ProtectedRoute>}
          />
        ))}

        <Route path="*" element={<Navigate to="/Dashboard" replace />} />
      </Routes>
    </>
  );
}

export default App;
